<template>
 <v-dialog v-model="dialogForward" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">far fa-comments</v-icon>&nbsp;&nbsp;{{$t('Dialog.forward.header')}}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text  style="padding-left: 30px;">
    <v-progress-linear :indeterminate="progress" v-if="status == 'progress' || statusGroup == 'progress'"></v-progress-linear>
      <v-container wrap style="padding-top:  0px;" v-else>
            <v-layout align-center justify-center wrap>
            <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
<!-- {{selectedRoomForward}} -->

            <v-tabs centered  dark icons-and-text color="white">
              <v-tabs-slider color="info"></v-tabs-slider>
                <v-tab href="#tab-1" :key="1" style="color: black !important; text-transform: none; background: white;" v-if="FriendList.length !== 0">
                  {{$t('Dialog.forward.friend')}}
                    <v-badge right>
        <span slot="badge"> {{FriendList.length}} </span>
                  <v-icon style="color: black !important; font-size: 25px !important;">person</v-icon>
                </v-badge>
                </v-tab>
                <v-tab href="#tab-2" :key="2" style="color: black !important; text-transform: none; background: white;" v-if="GroupList.length !== 0">{{$t('Dialog.forward.group')}}
                  <v-badge right>
        <span slot="badge"> {{GroupList.length}} </span>
         <v-icon style="color: black !important; font-size: 25px !important;">group</v-icon>
                   <!-- <img src='/static/img/icons/robot.svg' style="width: 25px;" class="alligator-turtle"> -->
                 </v-badge>
                </v-tab>

                <v-tabs-items>
                  <v-tab-item id="tab-1">
                   <v-list two-line style="max-height: 200px;" v-if="FriendList.length !== 0" class="scrolling-wrapper">
                    <template v-for="(item, index) in FriendList">
                      <v-divider v-if="index != 0"></v-divider>
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                        <v-list-tile-title style="width: 18em;">
                          {{item.name}}
                        </v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
          <v-checkbox v-model="selectedRoomForward" :value="item.tokenroom" style="float: right;"></v-checkbox>
                      </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>

                   <v-tab-item id="tab-2">
                    <v-list two-line style="max-height: 200px;" v-if="GroupList.length !== 0" class="scrolling-wrapper">
                    <template v-for="(item, index) in GroupList">
              <v-divider v-if="index != 0"></v-divider>
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.picture" :src="item.picture" class="alligator-turtle">
                          <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.name" style="width: 18em;"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                       <v-checkbox v-model="selectedRoomForward" :value="item.tokenroom" style="float: right;"></v-checkbox>
                      </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                      </v-tab-item>
</v-tabs-items>
</v-tabs>

            </v-flex>
            </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-layout align-center justify-center wrap >
      <v-btn color="red" flat @click.native="closeDialog" class="CSChatThai" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
      <v-btn color="blue darken-1" flat @click="sendForward()" class="CSChatThai" style="text-transform: none;">{{$t('AnswerQuestion.send')}}</v-btn>
    </v-layout>
    </v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

var _ = require('lodash')

export default {
  props: {dialogForward: false, selectedForward: ''},
  data: () => ({
    token: '',
    progress: false,
    status: 'progress',
    statusGroup: 'progress',
    GroupList: [],
    FriendList: [],
    search: '',
    selectedRoomForward: []
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.getlistfriend()
    this.getlistgroup()
  },
  watch: {
    socketaccept_friend () {
      this.getlistfriend()
    },
    socketremove_friend () {
      this.getlistfriend()
    },
    selectedRoomForward () {
      if (this.selectedRoomForward.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.forward.maxChatRoom'),
          'error'
        )
        _.pullAt(this.selectedRoomForward, [5])
      }
    }
  },
  computed: {
    ...sync('*')
  },
  methods: {
    closeDialog () {
      this.$emit('closeForward', false)
      this.selectedRoomForward = []
      this.search = ''
    },
    sendForward () {
      if (this.selectedRoomForward.length !== 0) {
        this.axios.post(process.env.APIimage + '/forward_file_message', {list_tokenroom: this.selectedRoomForward, tokenuser: this.token, list_tokenmessage: this.selectedForward}).then((response) => {
          if (response.data['status'] === 'success') {
            this.$swal(
              '',
              this.$t('Alert.Success.sendMsg'),
              'success'
            )
            this.closeDialog()
          } else {
            this.$swal(
              '',
              this.$t('Alert.Fail.default.somethingWrong'),
              'error'
            )
            this.closeDialog()
          }
        }, () => {
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          this.closeDialog()
        })
      }
    },
    getlistfriend () {
      this.status = 'progress'
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.token}).then((response) => {
        this.status = 'show'
        // console.log(response.data)
        this.FriendList = response.data['list_friend']
      })
    },
    getlistgroup () {
      this.statusGroup = 'progress'
      this.axios.post(process.env.APIgo_api + '/v1/get-list-group', {tokenuser: this.token}).then((response) => {
        this.statusGroup = 'show'
        // console.log(response.data['listgroup'])
        this.GroupList = response.data['list_active_group']
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_chat/ForwardDialog.vue